var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_user-agent.js
// module id = 1196
// module chunks = 1